// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-continue[data-v-42f0acb2] {\n  position: fixed;\n  bottom: 15px;\n  left: 0;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
